import {Divisions, Division} from "../Division";
import {Company} from "../Company";

export type CellData = XlsxStyle.Cell | string | boolean | number

export type RowData = {
    [key: number]: CellData
}

export const composeRow = (row: RowData): CellData[][] => [Object.keys(row).map(k => row[k])]

export const lpad = (n: number) => `0000${n}`.substr(-5, 5)

let companyCache = {}
let specialityCache = {}
let universityBranchCache = {}
let regionCache = {}

export const getCompany = (divisions: Divisions, companyId) => {
    if (!companyCache[companyId]) {
        divisions.map(({title, companies}: Division) => companies.map(({id, abbreviation, isOpk, region, city}: Company) => companyCache[id] = {
            division: title,
            company: abbreviation,
            isOpk,
            region,
            city,
        }))

        if (!companyCache[companyId]) {
            companyCache[companyId] = {
                division: "Неизвестен",
                company: `Неизвестно (${companyId})`,
                isOpk: false,
                region: "Неизвестен",
                city: "Неизвестен",
            }
        }
    }

    return companyCache[companyId]
}

export const getSpeciality = (specialities, specialityId) => {
    if (!specialityCache[specialityId] && specialities.has(specialityId)) {
        const {
            code,
            typeName,
            title,
            priority,
            category,
            isMaster,
            bachelorSpecialityId,
            period,
            isNuclear,
        } = specialities.get(specialityId)

        specialityCache[specialityId] = {
            code,
            typeName,
            title,
            priority,
            category,
            bachelorSpecialityId,
            master: isMaster(),
            nuclear: isNuclear(),
            period,
        }
    }

    return specialityCache[specialityId] || {}
}

export const getUniversityBranch = (universityBranches, universityBranchId) => {
    if (!universityBranchCache[universityBranchId] && universityBranches.has(universityBranchId)) {
        const {
            abbreviation,
            title,
            type,
//            specialitiesOpk,
            regionId,
        } = universityBranches.get(universityBranchId)

        universityBranchCache[universityBranchId] = {
            abbreviation,
            title,
            type,
//            specialitiesOpk,
            regionId,
        }
    }

    return universityBranchCache[universityBranchId] || {}
}

export const getRegion = (regions, regionId) => {
    if (!regionCache[regionId] && regions.has(regionId)) {
        const {
            name,
            district,
        } = regions.get(regionId)

        regionCache[regionId] = {
            name,
            district: {s: {border: {right: {style: "thin", color: {auto: 1}}}}, v: district},
        }
    }

    return regionCache[regionId] || {}
}